import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/tenants/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/tenants/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/tenants/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/tenants/delete',
    method: 'post',
    data
  })
}

